import React, { useState } from "react";
import { useDispatch, useStore, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import { Button, Row, Col, Spin, Form, Avatar, Popover, List, Tag } from "antd";
import moment from "moment";
import Placeholder from "../../assets/images/placeholder.svg";
import {
  closeAttribModal,
  closeAttribTabsModal,
  isEmptyObject,
  loadIncomingSale,
  loadIsShowSellAttribute,
  loadShowAttribDrop,
  saleIsInProgress,
} from "../../appRedux/actions";
import CustomScrollbars from "../../util/CustomScrollbars";

const ParkRetrieveListItem = (props) => {
  const { retrieveItem, type, callBack } = props;
  const dispatch = useDispatch();
  const history = useHistory();

  const [getIsSpinning, setIsSpinning] = useState(true);

  const getCurrentSalesOrderData = useSelector(
    ({ Sell }) => Sell.currentSalesOrderData
  );
  const showAttribDrop = useSelector(
    ({ commonConfigs }) => commonConfigs.showAttribDrop
  );
  const dropDownStates = useSelector(
    ({ commonConfigs }) => commonConfigs.dropDownStates
  );

  const handleClickParkedItem = (selectedParkedSaleData) => {
    if (!isEmptyObject(selectedParkedSaleData)) {
      if (!isEmptyObject(getCurrentSalesOrderData)) {
        saleIsInProgress(dispatch, selectedParkedSaleData);
      } else {
        loadIncomingSale(selectedParkedSaleData, dispatch);
      }
    }
    if (type && type == "retrieve") {
      callBack();
    } else if (type && type == "attrib") {
      closeAttribModal(dispatch, dropDownStates);
      closeAttribTabsModal(dispatch, dropDownStates);
    }
  };

  return (
    retrieveItem &&
    !isEmptyObject(retrieveItem) && (
      <List.Item
        onClick={() => {
          if (type && type != "showSale") {
            handleClickParkedItem(retrieveItem);
          }
        }}
        className="cursor-pointer"
      >
        <List.Item.Meta
          avatar={
            <Avatar src={Placeholder} className="dk-avatar-retrive-sale" />
          }
          // {retrieveItem.quantity}
          title={
            <div className="Receipt-data">
              {retrieveItem.products &&
                retrieveItem.products.map((prodObj, index) => (
                  <p key={index} className="custom-div-show ant-custom-mb-auto">
                    {prodObj.displayQuantity} × {prodObj.productName}
                  </p>
                ))}
            </div>
          }
          description={
            <>
              
                <div className="Receipt-data mt-3">
                  <p className="mb-2">
                    <IntlMessages id="sell.sell.retrievesell.parkedabout" />{" "}
                    {moment(retrieveItem.sellDate).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}{" "}
                    <IntlMessages id="sell.sell.retrievesell.by" />{" "}
                    {`${
                      retrieveItem && retrieveItem.soldBy
                        ? retrieveItem.soldBy
                        : "User"
                    }`}
                  </p>
                  {retrieveItem.notes != "" && retrieveItem.notes.length > 0 ? (
                    <p className="mb-2">
                      <span className="custom-font-color-black">
                        <IntlMessages id="sell.sell.retrievesell.note" />{" "}
                      </span>

                      {retrieveItem.notes}
                    </p>
                  ) : (
                    ""
                  )}
                  {retrieveItem.sellAttributes &&
                    retrieveItem.sellAttributes.length > 0 &&
                    retrieveItem.sellAttributes.map((as, io) => {
                      return (
                        <Tag key={io}>
                          {as.groupName ? `${as.groupName}: ` : ""}
                          {as.attributeName ? `${as.attributeName}` : ""}
                        </Tag>
                      );
                    })}
                  {retrieveItem.firstName && (
                   
                      <p className="mb-0">
                        <span className="custom-font-color-black">
                          Customer:{" "}
                        </span>
                        {retrieveItem.firstName != ""
                          ? retrieveItem.firstName
                          : "-"}{" "}
                        {retrieveItem.lastName != ""
                          ? retrieveItem.lastName
                          : "-"}{" "}
                      </p>
                    
                  )}
                
              </div>
            </>
          }
        />
      </List.Item>
    )
  );
};

export default ParkRetrieveListItem;
